import * as yup from 'yup'

const scheme = {
  info: yup.object().shape({
    firstname: yup.string().required('errors.form.empty'),
    name: yup.string().required('errors.form.empty'),
    mail: yup.string().required('errors.form.empty').email('errors.form.email'),
  }),
  edl: yup.object().shape({
    utilisateurInitiateurSignature: yup.string().required('errors.form.empty'),
    contactOrganisateur: yup.object().when(['clientAbsent'], {
      is: (clientAbsent: boolean) => clientAbsent,
      then: yup.object(),
      otherwise: yup.object().shape({
        nom: yup.string().required('errors.form.empty'),
        prenom: yup.string().required('errors.form.empty'),
        email: yup.string().required('errors.form.empty'),
        signatureFileUrl: yup.string().required('errors.form.empty'),
      }),
    }),
  }),
}

export default scheme
